// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles_nav__4YWuI","link":"styles_link__ahPcC","label":"styles_label__i0mqw","current":"styles_current___LECT","separator":"styles_separator__J5OFf"};